import { OnboardingLiveSlotPlanStatus } from "../gql/graphql.ts";
import { StatusBadge, StatusBadgeTone } from "../UI/StatusBadge.tsx";

const toneByStatus: Record<OnboardingLiveSlotPlanStatus, StatusBadgeTone> = {
  [OnboardingLiveSlotPlanStatus.Ok]: "success",
  [OnboardingLiveSlotPlanStatus.Warning]: "warning",
  [OnboardingLiveSlotPlanStatus.Blocked]: "danger",
};

const labelByStatus: Record<OnboardingLiveSlotPlanStatus, string> = {
  [OnboardingLiveSlotPlanStatus.Ok]: "OK",
  [OnboardingLiveSlotPlanStatus.Warning]: "Con avvisi",
  [OnboardingLiveSlotPlanStatus.Blocked]: "Bloccato",
};

export function PlanStatusBadge({
  status,
}: {
  status: OnboardingLiveSlotPlanStatus;
}) {
  return (
    <StatusBadge tone={toneByStatus[status]} label={labelByStatus[status]} />
  );
}
